/* src/app/modules/shared/components/header-column/header-column-effects/header-column-effects.component.scss */
app-header-column-effects {
  display: contents;
}
/*# sourceMappingURL=header-column-effects.component.css.map */
